// Units a form builder can pick for the client-api store radius in capture
// (webform_components_client_api.store_radius_unit).
const DistanceUnits = {
  MILES: 'miles',
  KM: 'km',
};

export default DistanceUnits;
